import React, { useContext, useState, useRef, useEffect } from 'react';
import { FormContext } from '../../context/FormContext';

const Step10 = ({ nextStep, prevStep }) => {
  const { formData, updateFormData } = useContext(FormContext);
  const [notes, setNotes] = useState(formData.notes);
  const stepTitleRef = useRef(null);

  useEffect(() => {
    if (stepTitleRef.current) {
      stepTitleRef.current.focus();
    }
  }, []);

  const handleNext = () => {
    updateFormData({ notes: notes || "" });
    nextStep();
  };

  return (
    <div>
      <h2 
        ref={stepTitleRef}
        tabIndex="-1"
        className="text-xl text-white font-bold mb-4 focus:outline-none"
      >
        9º Passo : Notas Adicionais (Opcional)
      </h2>
      <div className="mb-4">
        <label className="block mb-2 text-white">Por favor, anote aqui</label>
        <textarea rows="3" value={notes} onChange={(e) => setNotes(e.target.value)} className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"></textarea>
      </div>
      <div className="flex justify-between gap-2">
        <button
          onClick={prevStep}
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 items-center gap-2 w-full flex justify-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
          Voltar
        </button>
        <button
          onClick={handleNext}
          className="w-full flex justify-center items-center gap-x-2 rounded-md bg-[#0d6efd] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Seguinte
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m12.75 15 3-3m0 0-3-3m3 3h-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Step10;